module.exports = __webpack_public_path__ + "static/media/logoicon.b1063909.svg";